import { TranslationContextProvider } from 'schummar-translate/react';
import './WelcomeDetails.css';
import t from '../translations/translate.ts';
import logo from '../images/logo_thumb.png';
import { ifRightToLeft } from '../utils/ifLangDir.js';
import { useLocale } from '../LocaleContext';

export default function WelcomeThanks({ familyName }) {
    const { locale } = useLocale();
    return <TranslationContextProvider locale={locale}>
        <div
        style={{
            direction: ifRightToLeft() ? 'rtl' : 'ltr',
        }}
         className="base_background WelcomeDetails_root">
            <img className='WelcomeLogo' src={logo} />
            <div style={{ height: 20 }} />
            <div className="WelcomeDetails_form">
                <span className='_black_20_bold'>
                    {t('thanksFamily', { familyName: familyName })}
                </span>
                <br/><br/>
                <span className='_grey_16'>
                    {t('thanksText')}
                </span>
            </div>
        </div>
    </TranslationContextProvider>;
}
